import ApplicationLogo from '@/Components/ApplicationLogo';
import { useTone } from '@/Components/Marketing/Tone';
import { cn } from '@/lib/utils';

// The brand's exported colourways: primary on light, white-mono on dark.
const COLORWAY = { light: 'primary', dark: 'white' };

/**
 * The Synex wordmark for the marketing shell, in the surrounding tone.
 * Decorative: the link around it carries the name.
 */
export default function Logo({ tone, className }) {
    const resolved = useTone(tone);

    return (
        <span aria-hidden="true" className="inline-flex">
            <ApplicationLogo colorway={COLORWAY[resolved]} className={cn('w-auto overflow-visible', className)} />
        </span>
    );
}
